module.exports = __webpack_public_path__ + "img/google02.7e32f6ee.jpg";